import { AppModule } from "../../app/app.module";
import { AppConfig } from "../../config/app.config";
import { StorageProvider } from "../storage/storage";
import { AuthProvider } from "../auth/auth";
import { Storage } from "@ionic/storage";

export class DataProvider<T>{
    config = AppModule.injector.get(AppConfig);
    auth = AppModule.injector.get(AuthProvider);
    storage: StorageProvider<T>;

    constructor(private storageKey: string){
        this.storage = new StorageProvider<T>(AppModule.injector.get(Storage), storageKey);
    }
}


// WEBPACK FOOTER //
// ./src/providers/data/data.ts